<section class="colaboraciones" id="colaboraciones">
  <div class="colaboraciones__inner">

    <!-- Left: image -->
    <div class="colaboraciones__image">
      <img src="images/colaboraciones.png" alt="Colaboraciones y eventos privados Aruma" loading="lazy">
    </div>

    <!-- Right: text + cards -->
    <div class="colaboraciones__text">
      <div class="colaboraciones__heading">
        <span class="tag tag-outline">
          <span class="dot"></span>
          empresas, eventos y grupos privados
        </span>

        <h2 class="h2" style="color: var(--color-primary-950);">Colaboraciones y eventos privados</h2>

        <p class="body-m" style="color: var(--color-neutral-950);">
          Llevamos la creatividad y el bienestar a tu empresa, evento o grupo con experiencias diseñadas a medida.
        </p>

        <button class="btn btn-primary" (click)="scrollToContact()">
          Organizar una experiencia
        </button>
      </div>

      <!-- Cards list -->
      <div class="colaboraciones__cards">
        @for (card of cards; track card.title) {
          <div class="colaboraciones__card">
            <h3 class="colaboraciones__card-title label-caps">{{ card.title }}</h3>
            <p class="body-s" style="color: var(--color-neutral-950);">{{ card.description }}</p>
          </div>
        }
      </div>
    </div>

  </div>
</section>
